import { useEffect, useState } from 'react';

import { DATASOURCES_STATUS, isInSyncingByStatus, Logger, fetchDataSourcePollData } from '@futrli/shared-services';
import { toastError } from '@futrli/ui-components';

const REFRESH_INTERVAL = 10000;

export const useSyncStatusPolling = (datasourceId?: string | null) => {
  const [error, setError] = useState(false);
  const [startPolling, setStartPolling] = useState(false);
  const [syncingFinished, setSyncingFinished] = useState(false);

  // If datasource ID changes, reset error / syncing status
  useEffect(() => {
    setError(false);
    setSyncingFinished(false);
  }, [datasourceId]);

  // If we have a datasource ID and startPolling === true, start polling for data until sync complete
  useEffect(() => {
    let id: number;

    const fetchData = async () => {
      try {
        const fetchedPollData = await fetchDataSourcePollData(`datasource=${datasourceId}`);
        const isInSyncing = isInSyncingByStatus(fetchedPollData[0].sync_status as DATASOURCES_STATUS);
        if (!isInSyncing) {
          setStartPolling(false);
          setSyncingFinished(true);
          clearInterval(id);
        }
      } catch (e) {
        toastError();
        setError(true);
        clearInterval(id);
        setStartPolling(false);
        setSyncingFinished(true);
        Logger.error(e as string);
      }
    };

    if (datasourceId && startPolling) {
      id = window.setInterval(() => {
        fetchData();
      }, REFRESH_INTERVAL);
    }

    return () => {
      id && clearInterval(id);
    };
  }, [datasourceId, startPolling]);

  return {
    error,
    startPolling,
    setStartPolling,
    syncingFinished
  };
};
